import { TRootState } from '../../common/reducers';
import { selectArticle } from '../../common/selectors/helpCenter';
import { renderModel } from '../../util/renderModel';
import { biLogger } from '../biLogger';
import { selectBiData } from '../selectors';
import { ArticleBiData, BiEventLogger, CategoryBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logHomepagePresented: BiEventLogger = (state) => {
  void widgetPresentedContent({
    state,
  });
};

export const logCategoriesPresented: BiEventLogger<CategoryBiData[]> = (state, categories) => {
  void widgetPresentedContent({
    state,
  });
};

export const logCategorySolutionListPresented: BiEventLogger<ArticleBiData[]> = (state, articles) => {
  void widgetPresentedContent({ state });
};

export const logSingleArticlePresented: BiEventLogger<ArticleBiData> = (state, article) => {
  void widgetPresentedContent({
    state,
  });
};

export const logSearchResultsPresented: BiEventLogger<{
  articles: ArticleBiData[];
}> = (state) => {
  void widgetPresentedContent({ state });
};

async function widgetPresentedContent({ state }: { state: TRootState }): Promise<void> {
  const biData = selectBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);
  const contextPlatform = contextBi?.context_platform;

  if (contextPlatform === 'contact') {
    const article = selectArticle(state);
    const accountId = renderModel.getAccountId();
    const articleLocale = renderModel.getLocale();

    await biLogger.fullContactPageArticleView(state, {
      chatbot_conversation_id: biData.conversationId,
      self_service_session_id: sessionId,
      target_account_id: accountId,
      article_id: article?.id?.toString(),
      article_language: articleLocale,
    });
  }
}
